// src/hooks/useScope.ts
// Provides the current platform scope (productId, platformId, tenantId).
// Reads from the same env vars as main.tsx.

const scope = {
  platformId: import.meta.env.VITE_PLATFORM_ID || 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
  productId: import.meta.env.VITE_PRODUCT_ID || 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
  tenantId: import.meta.env.VITE_TENANT_ID || 'cccccccc-cccc-cccc-cccc-cccccccccccc',
};

export function useScope() {
  return scope;
}
